import { BsWifi, BsSnow, BsTv, BsShieldCheck, BsHouseDoor, BsHeadset, BsClock } from 'react-icons/bs';
import { MdPool, MdFitnessCenter, MdLocalLaundryService, MdRestaurant, MdOutlineLandscape } from 'react-icons/md';
import { FaCoffee, FaParking, FaWifi } from 'react-icons/fa';
import { IoCar, IoBed, IoRestaurantOutline } from 'react-icons/io5';

export const ICON_MAP = {
    'BsWifi': BsWifi,
    'BsSnow': BsSnow,
    'BsTv': BsTv,
    'BsShieldCheck': BsShieldCheck,
    'BsHouseDoor': BsHouseDoor,
    'BsHeadset': BsHeadset,
    'BsClock': BsClock,

    'MdPool': MdPool,
    'MdFitnessCenter': MdFitnessCenter,
    'MdLocalLaundryService': MdLocalLaundryService,
    'MdRestaurant': MdRestaurant,
    'MdOutlineLandscape': MdOutlineLandscape,

    'FaCoffee': FaCoffee,
    'FaParking': FaParking,
    'FaWifi': FaWifi,

    'IoCar': IoCar,
    'IoBed': IoBed,
    'IoRestaurantOutline': IoRestaurantOutline,
};

export function RenderIcon({ iconName, className = "text-xl" }) {
    if (!iconName || !ICON_MAP[iconName]) return null;

    const IconComponent = ICON_MAP[iconName];
    return <IconComponent className={className} />;
}